module.exports = __webpack_public_path__ + "static/media/home3.684dc272.svg";